export const GRIFFIN_REQUEST_BASEURL = 'txpb2/api/v1.1/me/{0}';
export const GRIFFIN_REQUEST_UNBLOCK = 'txpb2/api/v1.0/me/{0}';
export const USER_SETTINGS = 'UserSettings';
export const UNBLOCK = 'Unblock';
